// Added by sephora-jsx-loader.js
var React = require('react');
// Added by sephora-jsx-loader.js
var wrapComponentRenderModule = require('utils/framework/wrapComponentRender'); // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
var createClass = require('create-react-class')

// Added by sephora-jsx-loader.js
var wrapComponentRender = wrapComponentRenderModule.wrapComponentRender; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
var BccStyleWrapperClass;// Added by sephora-jsx-loader.js
Sephora.Util.InflatorComps.Comps['BccStyleWrapper'] = { 
    getReactClass: function BccStyleWrapper() { // eslint-disable-line max-len, func-name-matching
        return BccStyleWrapperClass;
    }
};
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
const localeUtils = require('utils/LanguageLocale');
const { space, mediaQueries } = require('style/config');

const BccStyleWrapper = function () {};

BccStyleWrapper.prototype.render = function () {

    const {
        className,
        customStyle = {},
        children,
        style,
        ...props
    } = this.props;

    if (localeUtils.isFRCanada() &&
        customStyle['FR_CA_HIDE'] !== undefined) {
        return null;
    }
    if (!localeUtils.isFRCanada() &&
        customStyle['FR_CA_SHOW'] !== undefined) {
        return null;
    }

    let paddingTop, paddingRight, paddingBottom, paddingLeft;

    if (customStyle['PADDING_TOP'] !== undefined) {
        paddingTop = parseInt(customStyle['PADDING_TOP']);
    }
    if (customStyle['PADDING_RIGHT'] !== undefined) {
        paddingRight = parseInt(customStyle['PADDING_RIGHT']);
    }
    if (customStyle['PADDING_BOTTOM'] !== undefined) {
        paddingBottom = parseInt(customStyle['PADDING_BOTTOM']);
    }
    if (customStyle['PADDING_LEFT'] !== undefined) {
        paddingLeft = parseInt(customStyle['PADDING_LEFT']);
    }

    return (
        <div
            children={children}
            className={className}
            css={[
                // set bg color around padded wrapper (BCC Markdown)
                children?.props?.backGroundColor && {
                    backgroundColor: children.props.backGroundColor
                },
                {
                    paddingTop,
                    paddingRight,
                    paddingBottom,
                    paddingLeft
                },
                // deprecated style padding props 
                (customStyle['TOP_PADDING'] !== undefined) && {
                    paddingTop: space[7],
                    [mediaQueries.smMax]: { 
                        paddingTop: space[6]
                    }
                },
                (customStyle['BOTTOM_PADDING'] !== undefined) && {
                    paddingBottom: space[7],
                    [mediaQueries.smMax]: { 
                        paddingBottom: space[6]
                    }
                },
                style
            ]}
            {...props} />
    );
};

// Added by sephora-jsx-loader.js
Sephora.Util.InflatorComps.Comps['BccStyleWrapper'].class = BccStyleWrapper; // eslint-disable-line max-len
// Added by sephora-jsx-loader.js
/* eslint-disable max-len */
// Added by sephora-jsx-loader.js
BccStyleWrapper.prototype.class = BccStyleWrapper.prototype.displayName = 'BccStyleWrapper';
// Added by sephora-jsx-loader.js
BccStyleWrapper.prototype.render = wrapComponentRender(BccStyleWrapper);
// Added by sephora-jsx-loader.js
// .jsx// Added by sephora-jsx-loader.js

BccStyleWrapper.prototype.getInitialState = function() {
    BccStyleWrapper.apply(this, this.props.constructorArgs);
    return this.state;
};
BccStyleWrapper.prototype.originClass = BccStyleWrapper;
BccStyleWrapperClass = createClass(BccStyleWrapper.prototype);
BccStyleWrapperClass.prototype.classRef = BccStyleWrapperClass;
Object.assign(BccStyleWrapperClass, BccStyleWrapper);
module.exports = BccStyleWrapperClass;
// Added by sephora-jsx-loader.js
/* eslint-enable max-len */
// Added by sephora-jsx-loader.js

